module.exports = __webpack_public_path__ + "img/plusFilled.d866c265.svg";